import Loader from 'components/Loader';
import React from 'react'

const GalleryLoader = () => {
  return (
    <div className="my-[100px] mx-auto flex items-center justify-center">
      <Loader />
    </div>
  );
}

export default GalleryLoader